import axios from '../axios'
// 废钢起运地列表
export const getPurDepartPlacePage = data => {
  return axios({
    url: '/api/sys/pur/depart/place/getPurDepartPlacePage',
    method: 'post',
    data
  })
}
// 删除废钢起运地
export const deletePurDepartPlaces = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/deletePurDepartPlaces',
    method: 'post',
    data
  })
}
//保存废钢起运地
export const savePurDepartPlace = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/savePurDepartPlace',
    method: 'post',
    data
  })
}
//修改废钢起运地
export const updatePurDepartPlace = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/updatePurDepartPlace',
    method: 'post',
    data
  })
}
//确认废钢起运地
export const auditPurDepartPlaces = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/auditPurDepartPlaces',
    method: 'post',
    data
  })
}
//反确认废钢起运地
export const unauditPurDepartPlaces = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/unauditPurDepartPlaces',
    method: 'post',
    data
  })
}
//禁用废钢起运地
export const forbidPurDepartPlaces = (data) => {
  return axios({
    url: '/api/sys/pur/depart/place/forbidPurDepartPlaces',
    method: 'post',
    data
  })
}

// 废钢等级表列表
export const getPurRankPage = (data) => {
  return axios({
    url: '/api/sys/pur/rank/getPurRankPage',
    method: 'post',
    data
  })
}
// 保存废钢等级表
export const savePurRank = (data) => {
  return axios({
    url: '/api/sys/pur/rank/savePurRank',
    method: 'post',
    data
  })
}
// 修改废钢等级表
export const updatePurRank = (data) => {
  return axios({
    url: '/api/sys/pur/rank/updatePurRank',
    method: 'post',
    data
  })
}
// 删除废钢等级表
export const deletePurRanks = (data) => {
  return axios({
    url: '/api/sys/pur/rank/deletePurRanks',
    method: 'post',
    data
  })
}
// 确认 auditFlag=1已确认
export const auditPurRanks = (data) => {
  return axios({
    url: '/api/sys/pur/rank/auditPurRanks',
    method: 'post',
    data
  })
}
// 反确认 auditFlag=0否
export const unauditPurRanks = (data) => {
  return axios({
    url: '/api/sys/pur/rank/unauditPurRanks',
    method: 'post',
    data
  })
}

//运输车辆种类列表
export const getSalVehicleTypePage = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/getSalVehicleTypePage',
    method: 'post',
    data
  })
}
//保存运输车辆种类
export const saveSalVehicleType = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/saveSalVehicleType',
    method: 'post',
    data
  })
}
//修改运输车辆种类
export const updateSalVehicleType = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/updateSalVehicleType',
    method: 'post',
    data
  })
}
//删除运输车辆种类
export const deleteSalVehicleTypes = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/deleteSalVehicleTypes',
    method: 'post',
    data
  })
}
//禁用启用 forbidStatus运输车辆种类
export const forbidSalVehicleTypes = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/forbidSalVehicleTypes',
    method: 'post',
    data
  })
}
//确认运输车辆种类
export const auditSalVehicleTypes = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/auditSalVehicleTypes',
    method: 'post',
    data
  })
}
//反确认运输车辆种类
export const unauditSalVehicleTypes = (data) => {
  return axios({
    url: '/api/sys/sal/vehicle/type/unauditSalVehicleTypes',
    method: 'post',
    data
  })
}

//废铁车辆来源地址列表
export const getMeterSourceAddressPage = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/getMeterSourceAddressPage',
    method: 'post',
    data
  })
}
//废铁车辆来源地址树状
export const getMeterSourceAddressTree = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/getMeterSourceAddressTree',
    method: 'post',
    data
  })
}
//保存废铁车辆来源地址
export const saveMeterSourceAddress = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/saveMeterSourceAddress',
    method: 'post',
    data
  })
}
//修改废铁车辆来源地址
export const updateMeterSourceAddress = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/updateMeterSourceAddress',
    method: 'post',
    data
  })
}
//删除废铁车辆来源地址
export const deleteMeterSourceAddresss = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/deleteMeterSourceAddresss',
    method: 'post',
    data
  })
}
//禁用/启用废铁车辆来源地址
export const forbidMeterSourceAddresss = (data) => {
  return axios({
    url: '/api/sys/meter/source/address/forbidMeterSourceAddresss',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/departure.js